import React, { useState, useEffect } from "react";
import "./CompanyList.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyFromAPI } from "../actions/currentCompany";
import CompanyDetails from "./CompanyDetails";

const CompanyListItem = ({ company }) => {
  const [view, setView] = useState("list");
  const dispatch = useDispatch();
  const currentCompany = useSelector((st) => st.currentCompany);

  useEffect(() => {
    setView(company.id === currentCompany.id ? "details" : "list");
  }, [currentCompany, company]);

  const handleClick = () => {
    dispatch(fetchCompanyFromAPI(company.id));
    setView("details");
  };

  const ListItem = () => (
    <div
      className="m-1 px-4 p-1"
      style={{ border: "1px solid grey", borderRadius: "5px" }}
      onClick={handleClick}
    >
      <h5>{company.name}</h5>
    </div>
  );

  // console.log({ company, view });

  return (
    <>
      {view === "list" && <ListItem />}
      {view === "details" && (
        <CompanyDetails
          companyId={company.id}
          backFunc={() => setView("list")}
        />
      )}
    </>
  );
};
export default CompanyListItem;
